/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MagicLinkIntentEnum {
    Login = 'login',
    SignUp = 'signUp'
}

export function MagicLinkIntentEnumFromJSON(json: any): MagicLinkIntentEnum {
    return MagicLinkIntentEnumFromJSONTyped(json, false);
}

export function MagicLinkIntentEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicLinkIntentEnum {
    return json as MagicLinkIntentEnum;
}

export function MagicLinkIntentEnumToJSON(value?: MagicLinkIntentEnum | null): any {
    return value as any;
}

